import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiGet } from '../api/client.js';

/**
 * Projects index — every project this org owns, with pillar/post/social
 * counts. Same data the Dashboard surfaces but in a dedicated full-page
 * list, navigable from the topbar.
 */
export default function Projects() {
  const q = useQuery({
    queryKey: ['projects-list'],
    queryFn: ({ signal }) => apiGet('/projects', { signal }),
  });

  return (
    <div className="projects-page">
      <header className="page-header">
        <div className="section-h-row">
          <h1>Projects</h1>
          <Link to="/projects/new" className="btn btn-compact">+ New project</Link>
        </div>
        <p className="muted">Every brand Markaii orchestrates marketing for. Click into a project to manage its pillars, plan, posts, and connected accounts.</p>
      </header>

      {q.isLoading && <div className="loading">Loading projects…</div>}
      {q.isError && <div className="error">Couldn’t load projects: {q.error.message}</div>}

      {q.data && q.data.projects.length === 0 && (
        <div className="empty">
          <p>No projects yet.</p>
          <p className="muted small">Projects are seeded via the workers <code>generate-plan</code> script today. A “New project” flow lands with ADR-0011.</p>
        </div>
      )}

      {q.data && q.data.projects.length > 0 && (
        <div className="project-grid">
          {q.data.projects.map((p) => (
            <Link key={p.id} to={`/projects/${p.key}`} className="project-card">
              <div className="project-card-head">
                <h2>{p.display_name}</h2>
                {p.ig_handle && <span className="ig-handle">{p.ig_handle}</span>}
              </div>
              {p.positioning && <p className="project-card-positioning">{p.positioning.slice(0, 180)}{p.positioning.length > 180 ? '…' : ''}</p>}
              <div className="project-card-stats">
                <span><b>{p.active_pillar_count}</b> pillars</span>
                <span><b>{p.post_count}</b> posts</span>
                <span><b>{p.social_account_count}</b> social</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
